import { render, staticRenderFns } from "./Og.vue?vue&type=template&id=7b7ca2af"
import script from "./Og.vue?vue&type=script&lang=js"
export * from "./Og.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports